import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import type {
  InitialStateType,
  SetLocationHubOptionsPayloadActionType,
  SetBlacklistDetailsPayloadActionType,
  SetBlacklistFormPayloadActionType,
  SetLocationDetailPayloadActionType,
  SLALongDeliveryType,
} from 'features/Location/@types/GreylistArea/AddEdit'

export const SLICE_NAME = 'GreylistArea/AddEdit'

export const initialState: InitialStateType = {
  isLoading: [],
  locationHubOptions: [],
  slaOptions: [],
  blacklistDetails: [],
  masterBlacklistDetails: [],
  blacklistForm: {
    address: '',
    duration_type: '',
    end_date: '',
    end_day: '',
    end_time: '',
    start_date: '',
    start_day: '',
    start_time: '',
    type: '',
    id: '',
    is_active: true,
    location: { id: 0, name: '', type: 'HUB' },
    filename: '',
    address_type: 0,
    close_reason: { id: 0, reason: '' },
    updated_by: '',
    file: '',
    service_level: {
      id: 0,
      name: '',
    },
    total_user: 0,
  },
  locationDetail: { location_address: '', location_id: 0, location_name: '', location_type: '' },
}

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    resetLocationDetail: (state) => {
      state.locationDetail = initialState.locationDetail
    },
    resetBlacklistForm: (state) => {
      state.blacklistForm = initialState.blacklistForm
    },
    resetBlacklistFormExceptLocation: (state) => {
      state.blacklistForm = {
        ...initialState.blacklistForm,
        location: state.blacklistForm.location,
      }
    },
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      if (payload) {
        state.isLoading.push(true)
      } else {
        state.isLoading.pop()
      }
    },
    setLocationHubOptions: (
      state,
      { payload }: PayloadAction<SetLocationHubOptionsPayloadActionType>,
    ) => {
      state.locationHubOptions = payload
    },
    setGreylistDetails: (
      state,
      { payload }: PayloadAction<SetBlacklistDetailsPayloadActionType>,
    ) => {
      state.blacklistDetails = payload
    },
    setMasterGreylistDetails: (
      state,
      { payload }: PayloadAction<SetBlacklistDetailsPayloadActionType>,
    ) => {
      state.masterBlacklistDetails = payload
    },
    addBlacklistDetail: (state) => {
      state.blacklistDetails.push(state.blacklistForm)
    },
    editBlacklistDetail: (state) => {
      const findIndex = state.blacklistDetails.findIndex((el) => el.id === state.blacklistForm.id)

      state.blacklistDetails[findIndex] = { ...state.blacklistForm }
    },
    removeBlacklistDetail: (state, { payload }: PayloadAction<number>) => {
      state.blacklistDetails.splice(payload, 1)
    },
    setBlacklistForm: (state, { payload }: PayloadAction<SetBlacklistFormPayloadActionType>) => {
      state.blacklistForm = { ...state.blacklistForm, ...payload }
    },
    setLocationDetail: (state, { payload }: PayloadAction<SetLocationDetailPayloadActionType>) => {
      state.locationDetail = { ...state.locationDetail, ...payload }
    },
    setSLAOptions: (state, { payload }: PayloadAction<SLALongDeliveryType[]>) => {
      state.slaOptions = payload
    },
  },
})

export const {
  reset,
  setIsLoading,
  setLocationHubOptions,
  setGreylistDetails,
  setBlacklistForm,
  addBlacklistDetail,
  removeBlacklistDetail,
  setLocationDetail,
  resetBlacklistForm,
  resetBlacklistFormExceptLocation,
  editBlacklistDetail,
  setSLAOptions,
  setMasterGreylistDetails,
} = slice.actions
export default slice.reducer
